<div class="container-fluid">
    <div class="row">
        <div class="col-md-3" *ngIf="showSideMenu">
            <a routerLink="/naac/ssr/criteria3"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>3.4</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/ssr/criteria3/3-4/3-4-1" (click)="checkRoute()">3.4.1</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/ssr/criteria3/3-4/3-4-2" (click)="checkRoute()">3.4.2</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/ssr/criteria3/3-4/3-4-3" (click)="checkRoute()">3.4.3</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="col-md-9" *ngIf="showHeading">
            <h4 class="text-center">Extension Activities</h4>
        </div>
        <div [ngClass]="fullWidth ? 'col-md-12' : 'col-md-9'">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>